import { registerComponent } from '@gig/magic-common';
import CreateLimitsComponent from './create-limits.vue.js';

var CreateLimits = registerComponent(CreateLimitsComponent);

export { CreateLimits };
